const Return = ({ onBackToLogin }) => {
    return (
        <div className="mt-4 text-center text-sm">
            <button
                onClick={onBackToLogin}
                className="w-full bg-white text-personalized text-xs py-1 transition
                    border border-personalized
                    hover:bg-personalized hover:text-white hover:border-transparent"
            >
                Volver al inicio de sesión
            </button>
        </div>
    );
};

export default Return;
